// SearchableBracketWrapper.js
import React, { useState, useEffect } from 'react';
import { renderSimpleBracket } from './BracketUtils';

const SearchableBracketWrapper = ({ bracketData, divisionName }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredMatches, setFilteredMatches] = useState(bracketData.matches || []);
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    setFilteredMatches(bracketData.matches || []);
  }, [bracketData]);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
  
    if (!query.trim()) {
      setFilteredMatches(bracketData.matches || []);
      setIsSearching(false);
      return;
    }
  
    setIsSearching(true);
    
    // Filter matches that contain the search query in teamA, teamB, or referee
    const results = (bracketData.matches || []).filter(match => {
      const teamALower = (match.teamA || '').toLowerCase();
      const teamBLower = (match.teamB || '').toLowerCase();
      const refereeLower = (match.referee || '').toLowerCase();
      
      return teamALower.includes(query) || 
             teamBLower.includes(query) || 
             refereeLower.includes(query);
    });
  
    // Add search match flags to the filtered matches
    const resultsWithFlags = results.map(match => ({
      ...match,
      teamAMatch: (match.teamA || '').toLowerCase().includes(query),
      teamBMatch: (match.teamB || '').toLowerCase().includes(query),
      refereeMatch: (match.referee || '').toLowerCase().includes(query)
    }));
  
    setFilteredMatches(resultsWithFlags);
  };

  const clearSearch = () => {
    setSearchQuery('');
    setFilteredMatches(bracketData.matches || []);
    setIsSearching(false);
  };

  // Highlight matching text function
  const highlightText = (text) => {
    if (!searchQuery.trim() || !text) return text;
    
    const parts = text.toString().split(new RegExp(`(${searchQuery})`, 'gi'));
    
    return parts.map((part, i) => {
      if (part.toLowerCase() === searchQuery.toLowerCase()) {
        return <span key={i} className="search-highlight">{part}</span>;
      }
      return part;
    });
  };

  // Prepare the data for rendering
  const dataForRendering = {
    ...bracketData,
    matches: filteredMatches
  };

  return (
    <div>
      <h2 className="section-title">{divisionName} Division Bracket</h2>
      
      <div className="search-container">
        <div className="search-input-wrapper">
        <input
            type="text"
            value={searchQuery}
            onChange={handleSearch}
            className="search-input"
            placeholder="Search for a player, team, or referee..."
            />
          {searchQuery && (
            <button className="clear-search" onClick={clearSearch}>×</button>
          )}
        </div>
        
        {isSearching && (
          <div className="search-info">
            Found {filteredMatches.length} match{filteredMatches.length !== 1 ? 'es' : ''}
          </div>
        )}
      </div>

      {isSearching && filteredMatches.length === 0 ? (
        <div className="no-search-results">
          No matches found for "{searchQuery}"
        </div>
      ) : (
        renderSimpleBracket(dataForRendering, highlightText)
      )}
    </div>
  );
};

export default SearchableBracketWrapper;